/**
 * Video Background
 */
function setup_video(e){
    var config = [];
    if($('#bgvid').length) config.push({el:"#bgvid", srcs:"#bgvid-srcs"});
    var attr_key = e==="desktop" ? "desktop-poster" : "mobile-poster"


    for(var i=0; i<config.length; i++){
        var vid_id = config[i].el;
        var video = $(vid_id);
        if(video.length){  
            var poster = video.attr(attr_key);
            video.attr("poster",poster);
			
            if($(config[i].srcs).length>0) {
				
                for(var o=JSON.parse($(config[i].srcs).text())[e],d=0;d<o.length;d++){
                    video.append('<source content="default-src *; style-src \'self\' http://* \'unsafe-inline\'; script-src \'self\' http://* \'unsafe-inline\' \'unsafe-eval\'" src="'+o[d].src+'" type="'+o[d].type+'">');
                }
            }    
        }
    }    
}

$(window).on("load", function() {
	650 < $(window).width() ?
		setup_video("desktop") :
		setup_video("mobile");
});

$(document).ready( function() {
	
	$( '.gallery-item' ).swipebox();
	
	$('.banner-slider').slick({
		dots: false,
		infinite: true,
		speed: 500,
		fade: true,
		autoplay: true,
		autoplaySpeed: 3000,
		cssEase: 'linear',
		arrows:false
	});

	$('.caret').on('click', function(){
		$(this).toggleClass('open');
		$(this).siblings('.sub-menu').slideToggle();
	})


	// mobile menu nav handling
	$('.menu-toggle').on('click', function(){
		$(this).toggleClass('closer');
		$('body').toggleClass('menu-open');
		$('.nav-primary').toggleClass('active');
	});
	
	$(".search-toggle").on('click', function(e){
		e.preventDefault();
		$('.site-search-form-container').addClass('active');
	});
	
	$(".site-search-form-container").on('click', function(e){
		var target = $(e.target);
		if(!target.hasClass('site-search-form') && !target.parents('.site-search-form').length){
			e.preventDefault();
			$('.site-search-form-container').removeClass('active');			
		}
	});
	
	$(".site-search-form-container .form-closer").on('click', function(e){	
		e.preventDefault();
		$('.site-search-form-container').removeClass('active');			
	});
	
	
	// sticky footer

	var minH = $(window).height() - ( $('header.banner').height() + $('.site-footer').height())+10;
	$('.wrap').css({minHeight:minH});		

	

	// // banner slider
	// if( $('.banner-slider') ) {
	// 	$('.banner-slider').slick({
	// 		arrows: false,
	// 		dots: false,
	// 		autoplay: true,
	// 		autoplaySpeed: 5000
	// 	});
	// }
	
	//init Swipe
	// $( '.swipebox' ).swipebox({
	// 	hideBarsDelay:0,
	// });

	//expander handling
	$('.expander-title').on("click", function() {
		$(this).toggleClass('open');
		$(this).siblings('.expander-content').slideToggle();
	})
});
/*

GOOGLE MAPS
var apiKey = '';
var lat = 1;
var lng = 1; 
$(document).ready(function(){
	if ($('#map').length){
	 	// Asynchronously Load the map API 
    var script = document.createElement('script');
    script.src = "//maps.googleapis.com/maps/api/js?callback=initialize&key="+apiKey;
    document.body.appendChild(script);	
	}
});
		
function initialize() {
	var location = {lat: lat, lng:lng}
	var map;
	var mapOptions = {
		zoom:15,
		center: location,
		scrollwheel: false
	};
	
	map = new google.maps.Map(document.getElementById("map"), mapOptions);       
	var marker = new google.maps.Marker({
		position: location,
		map: map,
	});                

}

*/

